import React, { useState } from "react";
import { AndroidLogoIcon, AppleLogoIcon } from "@phosphor-icons/react";
import { APP_PLATFORM_LOGO_MAP } from "../../../shared/constants";

interface AppLogoProps {
  logoUrl: string | null;
  platform: string;
  appName: string;
  className?: string;
}

const AppLogo: React.FC<AppLogoProps> = ({
  logoUrl,
  platform = "",
  appName,
  className,
}) => {
  const platformLogo = APP_PLATFORM_LOGO_MAP[platform?.toLowerCase() || ""];
  const [src, setSrc] = useState(logoUrl || platformLogo);
  const [hasError, setHasError] = useState(false);

  const isAndroid = platform?.toLowerCase() === "android" || platform?.toLowerCase() === "google_ads";
  const isIOS = platform?.toLowerCase() === "ios" || platform?.toLowerCase() === "apple_ads";

  const renderFallbackIcon = () => {
    if (isAndroid) {
      return <AndroidLogoIcon weight="fill" className="w-2/3 h-2/3 text-green-500 opacity-60" />;
    }
    if (isIOS) {
      return <AppleLogoIcon weight="fill" className="w-2/3 h-2/3 text-gray-500 opacity-60" />;
    }
    return <span className="text-[10px] font-bold text-gray-400 capitalize">{platform?.charAt(0)}</span>;
  };

  if (hasError || !src) {
    return (
      <div className={`w-full h-full flex justify-center items-center bg-gray-50 dark:bg-gray-800 rounded-md border border-gray-100 dark:border-gray-700 ${className}`}>
        {renderFallbackIcon()}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={appName}
      className={`w-full h-full object-cover rounded-md ${className} ${src === platformLogo ? "border border-gray-200 p-1" : ""
        }`}
      onError={() => {
        if (src !== platformLogo && platformLogo) {
          setSrc(platformLogo);
        } else {
          setHasError(true);
        }
      }}
    />
  );
};

export default AppLogo;
